import Store from "@/store";

export default async (next) => {
    let entry = false;
    let main = false;
    let text = false;

    if(Store.getters['entry_video/entry'].length > 0) {
        entry = true
    }

    await Store.getters['main_videos/main'].forEach(item => {

        if (item.control === 'main') {
            main = true
        }

        if(item.type === 'text') {
            text = true
        }

    })


    if(entry && main && text) {
        next()
    } else {
        next({name: 'Theme'})
    }
}